import axios from "axios";
import { useEffect, useState } from "react";
import "./SubredditDashboard.scss";
import { BASE_URL } from "../../api/api";
import Stats from "../../components/Stats/Stats";
import Overview from "../../components/Overview/Overview";
import Recommendation from "../../components/Recommendation/Recommendation";
import Spin from "../../components/Spin/Spin";
import { getURLParams } from "../../utils/helper";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import ErrorFallback from "../../components/ErrorFallback/ErrorFallback";

const DashboardContent = ({
  searchTerm,
  timeInterval,
  userData,
  setAnalysis,
  setSearchTerm,
}) => {
  const [data, setData] = useState({
    subscribers: "",
    subredditPulse: "",
    description: "",
    postsData: {},
    numPosts: 0,
  });

  const [error, setError] = useState(false);

  useEffect(() => {
    const { sr } = getURLParams(window.location.search);
    setSearchTerm(sr);
    document.title = `Eureka | Analysis for r/${sr}`;

    !sr && window.location.replace("/");
    setAnalysis(true);
  }, [setSearchTerm, setAnalysis]);

  useEffect(() => {
    const searchSubmitHandler = async () => {
      // reset error
      setError(false);
      // reset postsData state to display loading animation
      setData((prevData) => ({ ...prevData, postsData: {} }));

      const { n, t, sr } = getURLParams(window.location.search);

      try {
        const response = await axios.post(
          `${BASE_URL}/reddit/subreddit-analysis`,
          {
            subreddit: sr,
            nPosts: n,
            limit: t,
          }
        );

        const { metadata, customMetadata, postsData } = response.data;

        setData((prevData) => ({
          ...prevData,
          // metadata
          subscribers: metadata?.subscribers?.toLocaleString("en-US") || "",
          subredditPulse: customMetadata?.status || "N/A",
          description: metadata?.description || "N/A",
          // TOP submissionsData
          postsData: postsData?.data || {},
          numPosts: postsData?.numAnalyzed || 0,
        }));
      } catch (error) {
        console.log("Subreddit analysis error", error);
        setError(true);
      }
    };

    searchSubmitHandler();
  }, [searchTerm]);

  if (error) {
    return <ErrorFallback searchTerm={searchTerm} />;
  }

  if (!data.postsData || Object.keys(data.postsData).length === 0) {
    return <Spin />;
  }

  return (
    <section className="dashboard">
      <Overview
        searchTerm={searchTerm}
        subscribers={data.subscribers}
        subredditPulse={data.subredditPulse}
        description={data.description}
        sr={true}
      />
      <Recommendation
        recs={data.postsData.recs}
        searchTerm={searchTerm}
        userData={userData}
      />
      <Stats
        postsData={data.postsData}
        searchTerm={searchTerm}
        timeInterval={timeInterval}
        totalPosts={data.numPosts}
      />
    </section>
  );
};

const SubredditDashboard = ({
  searchTerm,
  timeInterval,
  userData,
  setAnalysis,
  setSearchTerm,
}) => {
  const { sr } = getURLParams(window.location.search);
  return (
    <ErrorBoundary fallback={<ErrorFallback searchTerm={sr} />}>
      <DashboardContent
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        timeInterval={timeInterval}
        setAnalysis={setAnalysis}
        userData={userData}
      />
    </ErrorBoundary>
  );
};
export default SubredditDashboard;
